import useConsentStore from '@scripts/stores/consent-store.js'

export default function useDomainConsent(url: string) {
    const domain = new URL(url).hostname

    const { domainEnabled, enableDomain } = useConsentStore()

    const isEnabled = domainEnabled(domain)
    const enable = () => enableDomain(domain)

    return {
        domain,
        isEnabled,
        enable,
    }
}
